/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import DeleteUploadicon from '../../svgs/DeleteUploadicon';
import NewUploadIcon from '../../svgs/NewUploadIcon';
import UploadedFileIcon from '../../svgs/UploadedFileIcon';
import Buttons from '../Buttons';
import TextInput from '../input';
import Gear from '../Loading/Gear';
import './ImageModalComp.scss';
import ModalFormComp from '../ModalFormComp';
import useToast from '../../customHooks/useToast';
import RolesAndPermissionGuard from '../RolesAndPermissionGuard';
import SelectSearch from '../SelectSearch';
import CheckboxNew from '../CheckboxNew';

type Props = {
  closeModal: any;
  title: string;
  viewOnly?: boolean;
  text: string;
  uploadFile: any;
  setUploadFile: any;
  value: string;
  handleChange: any;
  uploadLoading: boolean;
  onSubmit: any;
  checked?: boolean;
  setChecked?: any;
  allowIdentityDocument?: boolean;
  permissionName?:string
};

const documentTypes = [
  'NATIONAL_ID',
  'INTERNATIONAL_PASSPORT',
];

const ImageModalComp = ({
  closeModal,
  title,
  text,
  uploadFile,
  setUploadFile,
  viewOnly,
  value,
  handleChange,
  uploadLoading,
  onSubmit,
  checked,
  setChecked,
  allowIdentityDocument,
  permissionName,
}: Props) => {
  const Toast = useToast();

  return (
    <div className="file-upload-modal">
      <ModalFormComp removeTitle closeModal={closeModal} modalType="file-uploader" cancleDivWidth="(100%)">
        <div className="upload-wrapper">
          <div className="title-head">
            <h6>{title}</h6>
            <span>{text}</span>
          </div>
          {allowIdentityDocument && (
          <div className="checkbox-cover">
            <CheckboxNew
              id="status"
              onChange={(e) => {
                setChecked(!!e.target.checked);
              }}
              name="status"
              value={!!checked}
              loading={false}
              onClick={() => {}}
            >
              Check this box if you are uploading an identity document
            </CheckboxNew>
          </div>
          )}
          {
            (!checked || !allowIdentityDocument) ? (
              <TextInput
                name="documentType"
                value={value}
                label="Document Name"
                customOnChange={handleChange}
                viewOnly={viewOnly}
              />
            ) : (
              <SelectSearch
                label="Document Name"
                options={documentTypes?.map((type) => ({ label: type?.split?.('_')?.join(' ')?.toUpperCase?.(), value: type }))}
                placeholder="Select document type"
                name="documentType"
                value={value}
                required
                hideLabel
                onChange={handleChange}
                viewOnly={viewOnly}
              />
            )
          }
          <div className="file-upload-design">
            {!uploadFile ? (
              <label className="label" htmlFor="upload-file">
                <div className="no-file">
                  <NewUploadIcon />
                  <strong>Click to upload</strong>
                  <span>SVG, PNG, JPG or PDF (max. 800x400px)</span>
                </div>
              </label>
            )
              : (
                <>
                  <span style={{ visibility: uploadLoading ? 'visible' : 'hidden' }} className="uploading">Uploading...</span>
                  <div className="has-file pointer">
                    <UploadedFileIcon />
                    <div className="file-info">
                      <strong>{uploadFile?.name}</strong>
                      <div className="flexed-row gear-cover">
                        <small>{`${(uploadFile?.size || 0) / 1000} KB`}</small>
                        {uploadLoading && <Gear />}
                      </div>
                    </div>
                    <div onClick={() => setUploadFile(null)} className="pointer"><DeleteUploadicon /></div>
                  </div>

                </>
              )}
            <input
              onChange={({ target }: any) => {
                const [fileUpload] = target.files || [];
                if (!fileUpload) Toast.error('Invalid ');
                setUploadFile(fileUpload);
              }}
              type="file"
              name="upload-file"
              id="upload-file"
              accept="image/*, application/pdf"
              // max={5480}
              disabled={uploadLoading}
            />
          </div>
          <div className="twin-buttons-cover">
            <Buttons
              name="Cancel"
              className="cancel-type"
              onClick={closeModal}
            />
            <RolesAndPermissionGuard permissionName={permissionName}>
              <Buttons
                name={uploadLoading ? 'Uploading...' : 'Upload'}
                className="save-type"
                type="submit"
                btnStyle="btn-md"
                onClick={onSubmit}
                disabled={uploadLoading}
              />
            </RolesAndPermissionGuard>

          </div>
        </div>
      </ModalFormComp>
    </div>
  );
};

export default ImageModalComp;
